export const menuItems = [
    { title: "Главная", link: "/main" },
    {
        title: "Программы",
        link: "/treatment",
        submenu: [
            {
                title: "Процедуры",
                link: "/treatment",
                submenu: [
                    { title: "Массаж", link: "/treatment" },
                    { title: "Спорт", link: "/treatment" },
                    { title: "Озонотерапия", link: "/treatment" },
                    { title: "Карбокситерапия", link: "/treatment" },
                    { title: "Бальнеотерапия", link: "/treatment" },
                    { title: "Очищение кишечника", link: "/treatment" },
                    { title: 'Физиотерапия', link: "/treatment" },
                ]
            },
            {
                title: "Основные программы",
                link: "/treatment",
                submenu: [
                    { title: "Базовая", link: "/treatment" },
                    { title: "Базовая премиум", link: "/treatment" },
                    { title: "Детокс", link: "/treatment" },
                    { title: "Крепкий иммунитет", link: "/treatment" }
                ]
            },
        ]
    },
    {
        title: "СПА",
        link: "/spa",
        submenu: [
            { title: "СПА-Программы", link: "/spa" },
            { title: "СПА-Процедуры", link: "/spa" },
            { title: "Массажи", link: "/spa" }
        ]
    },
    {
        title: "Номера",
        link: "/rooms",
        submenu: [
            { title: "Клубный этаж ", link: "/rooms" },
            { title: "Основной корпус", link: "/rooms" },
        ]
    },
    {
        title: "Услуги",
        link: "/food",
        submenu: [
            { title: "Досуг", link: "/food" },
            { title: "Инфраструктура", link: "/food" }
        ]
    },
    {title: "Информация",link: "/info",}
];